<template>
  <div class="main-dashboard-panel">
    <OrganizationEdit v-if="user.isOrganizer" :org-id="org.id" />
  </div>
</template>

<script>
import OrganizationEdit from '@/modules/organizations/OrganizationEdit'
import { mapState } from 'vuex'

export default {
  components: { OrganizationEdit },
  computed: mapState({
    user: (state) => state.user.data,
    org: (state) => {
      const org = _.first(state.user.data.organizations)
      if (org) {
        return org
      } else {
        return {}
      }
    },
  }),
}
</script>
